import React from "react";
import { useTranslation } from "react-i18next";
import CheckboxInput from "../../../components/inputs/CheckboxInput";

interface MusterPointsSectionProps {
  selectedLocationId: string;
  musterPointsOptions: Array<{
    id: number;
    label: string;
  }>;
  selectedMusterPoints: number[];
  onToggleMusterPoint: (pointId: number) => void;
  disabled?: boolean;
}

const MusterPointsSection: React.FC<MusterPointsSectionProps> = ({
  selectedLocationId,
  musterPointsOptions,
  selectedMusterPoints,
  onToggleMusterPoint,
  disabled= false,
}) => {
  const { t } = useTranslation();

  if (!selectedLocationId) return null;

  return (
    <div className="flex flex-col gap-3">
      <p>
        {t("2")}. {t("musterPoints")}
      </p>

      {musterPointsOptions.length > 0 ? (
        <div className="flex flex-wrap items-center gap-x-10 gap-y-4">
          {musterPointsOptions.map((option) => (
            <div key={option.id}>
              <CheckboxInput
                id={String(option.id)}
                label={option.label}
                labelStyles="text-sm"
                checked={selectedMusterPoints.includes(option.id)}
                setChecked={() => onToggleMusterPoint(option.id)}
                readOnly={disabled}
              />
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500">
          {t("noMusterPointsAvailableForSelectedLocation")}
        </p>
      )}
    </div>
  );
};

export default MusterPointsSection;
